import moment from "moment"
import { useContext, useEffect, useRef, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import { DateRangePicker } from "react-dates"
import { AbsoluteContainer, AppSpan, CustomContainer, FlexRow, GridContainer } from "src/style"
import { IoMapOutline } from "react-icons/io5";
import { IoListOutline } from "react-icons/io5";
import { AddressMapView, Portal, ServerSideTable, Table } from "src/component";
import { addressColumn, addressData } from "src/utils/tableLayout";

export const LocationHistory: React.FC<any> = ({customerId}) => {
    const {API} = useContext(ApiContext)
    const [navPosition, setNavPosition] = useState(0)
    const [viewNavPosition, setViewNavPosition] = useState(0)
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment().add(7, 'd'));
    const [focusedInput, setFocusedInput] = useState(null);
    const [locationInfo, setLocationInfo] = useState<any>(null)
    const [locations, setLocations] = useState<any[]>([])

    const dateRef = useRef<any>({})

    useEffect(() => {
        dateRef.current = {}
        handleFetchCustomerLocations()
    }, [navPosition]) 

    async function handleFetchCustomerLocations (pageNumber = 1, pageSize = 10) {
        const response = await API.getCustomerLocations({
            page: pageNumber, 
            size: pageSize,
            mostFrequent: navPosition != 0,
            from: dateRef.current.from,
            to: dateRef.current.to
        }, 
            customerId
        )

        if (response) {
            setLocationInfo(response)
            setLocations(response.data)
        }
    }

    function onDateChange({startDate, endDate}: any) {
        setStartDate(startDate);
        setEndDate(endDate);
        
        if (startDate && endDate && focusedInput === 'endDate') {
            const from = startDate.toISOString()?.split('T')[0]
            const to = endDate.toISOString()?.split('T')[0]

            dateRef.current = {from, to}

            handleFetchCustomerLocations()
        }
    }

    function onFocusChange(focusedInput: any) {
        setFocusedInput(focusedInput);
    }

    return (
        <CustomContainer>
            <FlexRow 
                justifyContent="space-between" gap="3.5"
                alignItems="flex-start"
                wrap="wrap"
            >
                <GridContainer
                    height="4" width='41.2'
                    bgColor="#E0E0E0" radius="0.4"
                    borderColor="#E0E0E0"
                    className='scrollable-container'
                >
                    <AbsoluteContainer 
                        width={navPosition === 0 ? '19' : '22'} 
                        top="0" left={`${navPosition}`}
                    >
                        <CustomContainer 
                            bgColor="#F0ECFF" 
                            borderColor="#5627FF"
                            radius="0.4" height="3.8"
                        />
                    </AbsoluteContainer>
                    <FlexRow
                        alignItems='flex-start'
                        gap='2'
                        style={{zIndex: '2'}}
                    >
                        <GridContainer 
                            width='19'
                            leftPadding="1" rightPadding="1"
                            onClick={() => setNavPosition(0)}
                        >
                            <AppSpan  
                                cursor="pointer"
                                fontWeight={navPosition === 0 ? "700" : "400"}
                                color={navPosition === 0 ? "#5627FF" : "#828282"}
                            >
                                All Address
                            </AppSpan>
                        </GridContainer>
                        <GridContainer 
                            width='19'
                            leftPadding="1" rightPadding="1"
                            onClick={() => setNavPosition(19)}
                        >
                            <AppSpan  
                                cursor="pointer"
                                fontWeight={navPosition === 19 ? "700" : "400"}
                                color={navPosition === 19 ? "#5627FF" : "#828282"}
                            >
                                Most Frequent Addresses
                            </AppSpan>
                        </GridContainer>
                    </FlexRow>
                </GridContainer>
                
                <FlexRow 
                    wrap="wrap" gap="1.5" 
                    width="auto" sizeUnit=""
                >
                    <DateRangePicker
                        startDate={startDate}
                        startDateId="address_start_date"
                        endDate={endDate}
                        endDateId="address_end_date"
                        onDatesChange={onDateChange}
                        focusedInput={focusedInput}
                        onFocusChange={onFocusChange}
                        isOutsideRange={() => false}
                    />
                    <GridContainer
                        height="4" width='23'
                        bgColor="#ffffff" radius="0.4"
                        borderColor="#BDBDBD"
                        //className='scrollable-container'
                    >
                        <AbsoluteContainer 
                            width='50' sizeUnit="%"
                            top="0" left={`${viewNavPosition}`} lSizeUnit='%'
                        >
                            <GridContainer height="4">
                                <CustomContainer 
                                    bgColor="#5627FF" 
                                    borderColor="#5627FF"
                                    radius="0.4" height="3"
                                    leftMargin={viewNavPosition === 0 ? "0.8" : "0"}
                                    rightMargin={viewNavPosition === 50 ? "0.8" : "0"}
                                />
                            </GridContainer>
                        </AbsoluteContainer>
                        <FlexRow
                            alignItems='flex-start'
                            style={{zIndex: '2'}}
                        >
                            <FlexRow 
                                width='50' sizeUnit="%" gap="5"
                                leftPadding="0.8" rightPadding="0.8"
                                onClick={() => setViewNavPosition(0)}
                            >
                                <IoListOutline color={viewNavPosition === 0 ? '#ffffff' : "#828282"} fontSize='1.8rem' />
                                <AppSpan  
                                    cursor="pointer"
                                    fontWeight={viewNavPosition === 0 ? "700" : "400"}
                                    color={viewNavPosition === 0 ? "#ffffff" : "#828282"}
                                >
                                    List View
                                </AppSpan>
                            </FlexRow>
                            <FlexRow 
                                width='50' sizeUnit="%" gap="5"
                                leftPadding="0.8" rightPadding="0.8"
                                onClick={() => setViewNavPosition(50)}
                            >
                                <IoMapOutline color={viewNavPosition === 50 ? '#ffffff' : "#828282"} />
                                <AppSpan  
                                    cursor="pointer"
                                    fontWeight={viewNavPosition === 50 ? "700" : "400"}
                                    color={viewNavPosition === 50 ? "#ffffff" : "#828282"}
                                >
                                    Map View
                                </AppSpan>
                            </FlexRow>
                        </FlexRow>
                    </GridContainer>
                </FlexRow>
            </FlexRow>

            { viewNavPosition === 0 ?
                <CustomContainer topMargin='4'>
                    <ServerSideTable
                        tableColumns={addressColumn}
                        tableData={locations}
                        dataFetchMethod={handleFetchCustomerLocations}
                        totalRows={locationInfo?.totalResults}
                        noDataText='No Address Locations'
                        noRadius
                    />
                </CustomContainer>
                :
                <AddressMapView locations={locations} />
            }
        </CustomContainer>
    )
}